import { render, staticRenderFns } from "./Ailment.vue?vue&type=template&id=096f1456"
import script from "./Ailment.vue?vue&type=script&lang=ts"
export * from "./Ailment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports